import { unstable_OneTimePasswordField as OneTimePasswordField } from "radix-ui";
import OtpInput from "../../../atoms/controls/input/OtpInput";

const OtpInputField = ({ value, onValueChange, length = 6 }) => {
  return (
    <OneTimePasswordField.Root
      className="flex gap-2 flex-nowrap"
      value={value}
      onValueChange={onValueChange}
    >
      {Array.from({ length }).map((_, i) => (
        <OtpInput key={i} index={i} />
      ))}
      <OneTimePasswordField.HiddenInput />
    </OneTimePasswordField.Root>
  );
};

export default OtpInputField;
